import { render, staticRenderFns } from "./PagamentoLotesGroupedTable.vue?vue&type=template&id=2cf05f90"
import script from "./PagamentoLotesGroupedTable.vue?vue&type=script&lang=js"
export * from "./PagamentoLotesGroupedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports